import { version } from "moment-timezone";

export const environment = {
  nome: 'prod',
  production: true,
  version: "1.0.32"
}
